import { OvlAddComponent } from "../../../_ovlclient/src/global/globals"
import { CompSYSBackButton } from "./parts/backbutton"
import { CompSYSShellbarHint } from "./parts/hint"
import { CompSYSRefreshButton } from "./parts/refresh"
import { CompSYSShellbar } from "./parts/shellbar"

export const SYSShellbar_Init = () => {
  OvlAddComponent("comp-sysshellbar", CompSYSShellbar)
  OvlAddComponent("comp-sysbackbutton", CompSYSBackButton)
  OvlAddComponent("comp-sysshellbarhint", CompSYSShellbarHint)
  OvlAddComponent("comp-sysrefreshbutton", CompSYSRefreshButton)
}
